<div [ngClass]="{ 'ml-1': !submenuLabel }">
  <div
    #menu
    class="menu-container"
    [ngClass]="['dropdown', theme, noIconClass]">
    @if (!submenuLabel && icon) {
      <button
        id="action-menu-button"
        [ngClass]="[buttonClass, isGhostClass, isSmallClass, isTinyClass, isMediumClass, isLargeClass]"
        [disabled]="disabled"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        (click)="toggleMenu()">
        <i id="action-menu-icon" class="icon icon-{{ icon }}"></i>
      </button>
    }
    @if (submenuLabel) {
      <div
        class="dropdown-item"
        (click)="toggleMenu()"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        aria-haspopup="true"
        aria-controls="dropdown-menu">
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          <i class="icon icon-{{ icon }}"></i>
          <div class="ml-2">{{ submenuLabel }}</div>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="end center">
          <i class="icon sub-menu icon-caret_down"></i>
        </div>
      </div>
    }
    @if (!disabled) {
      <div
        #dropdownMenu
        class="dropdown-menu"
        id="dropdown-menu"
        role="menu"
        >
        <div
          class="dropdown-content drop-shadow-3"
          [ngClass]="contentClass">
          <ng-content></ng-content>
        </div>
      </div>
    }
  </div>
</div>
